package com.essntl.features.request.domain.model

data class RequestFilterOptions(
    val searchText: String = "",
    val selectedRequestStatus: RequestModel.Status? = null,
    val selectedProfileIds: Set<String> = emptySet(),
)